import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { Page, Toolbar } from 'react-onsenui'
import PreferencesIcon from '@material-ui/icons/Settings'
import NotificationsIcon from '@material-ui/icons/Notifications'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import LogoutIcon from '@material-ui/icons/ExitToApp'

import ConfirmDialog from 'components/ConfirmDialog'

import backgroundImg from 'images/entries/header-entries.png'

import { appName, headerStyles, images } from '../Styles'

const HomeScreen = props => {
  const fullUser = (props.me && props.me.only_forecasts === 0) ? true : false

  return (
    <Page>
      <Toolbar modifier="transparent">
        <div className="left">
          <PreferencesIcon className={props.classes.btPreferences} onClick={() => props.goTo('preferences')} />
        </div>
        <div className="right">
          {fullUser && (
            props.notificationsUnreadCount() ? (
              <NotificationsIcon
                className={props.classes.btNotifications + ' ' + props.classes.hasNotifications}
                onClick={() => props.goTo('notifications')}
              />
            ) : (
              <NotificationsNoneIcon
                className={props.classes.btNotifications}
                onClick={() => props.goTo('notifications')}
              />
            )
          )}

          <LogoutIcon className={props.classes.btLogout} onClick={props.openLogoutConfirmDialog} />
          <ConfirmDialog
            title="Cerrar sesión"
            open={props.logoutConfirmDialogOpen}
            onOk={() => props.logout()}
            onCancel={() => props.closeLogoutConfirmDialog()}>
            ¿Estás seguro de qué deseas salir de tu cuenta en la aplicación de {appName}?
          </ConfirmDialog>
        </div>
      </Toolbar>

      <Hidden xsDown>
        <div className={props.classes.background} />
      </Hidden>

      <div className={props.classes.container}>
        <div
          className={props.classes.row + ' ' + props.classes.spacing + ' ' + props.classes.headerRow + ' '}
          style={{ backgroundImage: `url(${images.header})`, backgroundSize: headerStyles.backgroundSize, backgroundRepeat: headerStyles.backgroundRepeat }}
        />
        {/* <div
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.keyCode === 69) props.goTo('entries')
          }}
          onClick={() => props.goTo('entries')}
          className={props.classes.row + ' ' + props.classes.spacing + ' ' + props.classes.imageBorderAndShadow}
          style={{ backgroundImage: `url(${images.clasifications})` }}
        />
        <div
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.keyCode === 83) props.goTo('samplings')
          }}
          onClick={() => props.goTo('samplings')}
          className={props.classes.row + ' ' + props.classes.spacing + ' ' + props.classes.imageBorderAndShadow}
          style={{ backgroundImage: `url(${btClassificationsImg})` }}
        /> */}
        <div className={props.classes.parentRow + ' ' + props.classes.spacing}>
          <Grid container>
            <Grid xs className={fullUser ? null : props.classes.translucent}>
              <div
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 69) fullUser && props.goTo('entries')
                }}
                onClick={() => fullUser && props.goTo('entries')}
                className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}
                style={{ backgroundImage: `url(${images.entries})`, marginRight: 7 }}
              />
            </Grid>
            <Grid xs className={fullUser ? null : props.classes.translucent}>
              <div
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 83) fullUser && props.goTo('samplings')
                }}
                onClick={() => fullUser && props.goTo('samplings')}
                className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}
                style={{ backgroundImage: `url(${images.clasifications})`, marginLeft: 7 }}
              />
            </Grid>
          </Grid>
        </div>
        <div className={props.classes.parentRow + ' ' + props.classes.spacing}>
          <Grid container>
            {/*<Grid xs className={fullUser ? null : props.classes.translucent}>*/}
            {/*  <div*/}
            {/*    role="button"*/}
            {/*    tabIndex={0}*/}
            {/*    onKeyDown={e => {*/}
            {/*      if (e.keyCode === 73) fullUser && props.goTo('invoices')*/}
            {/*    }}*/}
            {/*    onClick={() => fullUser && props.goTo('invoices')}*/}
            {/*    className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}*/}
            {/*    style={{*/}
            {/*      backgroundImage: `url(${btInvoicesImg})`,*/}
            {/*      marginRight: 7,*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</Grid>*/}

            <Grid xs className={fullUser ? null : props.classes.translucent}>
              <div
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 67) fullUser && props.goTo('containers')
                }}
                onClick={() => fullUser && props.goTo('containers')}
                className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}
                style={{ backgroundImage: `url(${images.container})`, marginLeft: 7 }}
              />
            </Grid>
            <Grid xs className={fullUser ? null : props.classes.translucent}>
              <div
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 84) fullUser && props.goTo('stats')
                }}
                onClick={() => fullUser && props.goTo('stats')}
                className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}
                style={{ backgroundImage: `url(${images.stats})`, marginLeft: 7 }}
              />
            </Grid>
          </Grid>
        </div>
        <div className={props.classes.parentRow + ' ' + props.classes.spacing}>
          <Grid container>
            {/*<Grid xs>*/}
            {/*  <div*/}
            {/*    role="button"*/}
            {/*    tabIndex={0}*/}
            {/*    onKeyDown={e => {*/}
            {/*      if (e.keyCode === 70) props.goTo('forecasts')*/}
            {/*    }}*/}
            {/*    onClick={() => props.goTo('forecasts')}*/}
            {/*    className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}*/}
            {/*    style={{ backgroundImage: `url(${btForecastImg})`, marginRight: 7 }}*/}
            {/*  />*/}
            {/*</Grid>*/}
            {/*<Grid xs className={fullUser ? null : props.classes.translucent}>*/}
            {/*  <div*/}
            {/*    role="button"*/}
            {/*    tabIndex={0}*/}
            {/*    onKeyDown={e => {*/}
            {/*      if (e.keyCode === 67) fullUser && props.goTo('containers')*/}
            {/*    }}*/}
            {/*    onClick={() => fullUser && props.goTo('containers')}*/}
            {/*    className={props.classes.row + ' ' + props.classes.imageBorderAndShadow}*/}
            {/*    style={{ backgroundImage: `url(${btContainersImg})`, marginLeft: 7 }}*/}
            {/*  />*/}
            {/*</Grid>*/}
          </Grid>
        </div>
      </div>
    </Page>
  )
}

const styles = {
  btPreferences: {
    padding: 10,
    color: '#DDD',
    cursor: 'pointer',
  },
  btNotifications: {
    padding: 10,
    color: '#DDD',
    cursor: 'pointer',
  },
  btLogout: {
    padding: 10,
    color: '#DDD',
    cursor: 'pointer',
  },
  hasNotifications: {
    color: '#D60000',
  },
  dimmed: {
    opacity: '.3 !important',
  },
  rowImage: {},
  background: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url('${backgroundImg}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.1,
  },
  container: {
    position: 'relative',
    width: '100%',
    maxWidth: 400,
    height: '100vh',
    margin: '0 auto',
    textAlign: 'center',
    zIndex: 100,
  },
  row: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '23vh',
    cursor: 'pointer',
  },
  parentRow: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '23vh',
    cursor: 'pointer',
  },
  imageBorderAndShadow: {
    borderRadius: '10px',
    boxShadow: 'rgba(0, 0, 0, .25) 0 0 10px',
  },
  spacing: {
    marginTop: '2vh',
  },
  headerRow: {
    //    backgroundSize: 'contains'
  },
  translucent: {
    opacity: .25,
  }
}

export default withStyles(styles)(HomeScreen)



// WEBPACK FOOTER //
// ./src/screens/HomeScreen.js